export default __webpack_public_path__ + "static/media/vs.df281ec2.jpg";